import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { getFormattedPrice } from 'utils/currency';

import {
  ReportItemContainer,
  Divider,
  ReportValueBudget,
  ReportSubItem,
  ReportValueText,
  ReportValueTitle,
} from './styles';

interface Props {
  totalTripsValues?: number;
  totalTrips?: number;
  currency?: string;
  totalTrip?: number;
  totalAir?: number;
  totalAirValues?: number;
  totalHotel?: number;
  totalHotelValues?: number;
}

const ReportItem = ({
  totalTripsValues,
  totalTrips,
  currency,
  totalAir,
  totalAirValues,
  totalHotel,
  totalHotelValues,
}: Props) => {
  const { t } = useStoreTranslation();
  const formattedPrice = (value: number | undefined) => {
    const { formatted } = getFormattedPrice({ value, currency, t });
    return formatted;
  };

  return (
    <>
      <ReportItemContainer>
        <ReportValueTitle>{t('travelReport.reportSummary.tripsMade')}</ReportValueTitle>
        <Divider />
        <ReportValueBudget>
          <ReportValueText>{formattedPrice(totalTripsValues || 0)}</ReportValueText>
          <ReportSubItem>{t('travelReport.reportSummary.tripsMadeQuantity', { number: totalTrips })}</ReportSubItem>
        </ReportValueBudget>
      </ReportItemContainer>
      <ReportItemContainer>
        <ReportValueTitle>{t('travelReport.reportSummary.flight')}</ReportValueTitle>
        <Divider />
        <ReportValueBudget>
          <ReportValueText>{formattedPrice(totalAirValues || 0)}</ReportValueText>
          <ReportSubItem>{t('travelReport.reportSummary.tripsMadeQuantity', { number: totalAir })}</ReportSubItem>
        </ReportValueBudget>
      </ReportItemContainer>
      <ReportItemContainer>
        <ReportValueTitle>{t('travelReport.reportSummary.hotel')}</ReportValueTitle>
        <Divider />
        <ReportValueBudget>
          <ReportValueText>{formattedPrice(totalHotelValues || 0)}</ReportValueText>
          <ReportSubItem>{t('travelReport.reportSummary.tripsMadeQuantity', { number: totalHotel })}</ReportSubItem>
        </ReportValueBudget>
      </ReportItemContainer>
    </>
  );
};

export default ReportItem;
